<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-space-y-4 mb-4">
      <div class="row mb-2">
        <div class="col-md-6">
          <label class="required">{{
            $t('certificateOperationPrint.academicYear')
          }}</label>
          <a-select
            style="width: 100%"
            v-model.number="model.ac_year_id"
            :options="ac_year_list"
          ></a-select>
          <div class="validate" v-if="errors.has('ac_year_id')">
            {{ errors.first('ac_year_id') }}
          </div>
        </div>
        <div class="col-md-6">
          <label class="required">{{
            $t('certificateOperationPrint.mainProgram')
          }}</label>
          <a-select
            style="width: 100%"
            v-model.number="model.acp_id"
            :options="main_programs"
            @change="onChangeMainProgram(model.acp_id)"
          ></a-select>
          <div class="ts-flex ts-justify-start text-danger">
            {{ errors.first('acp_id') }}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6">
          <label class="required">{{
            $t('certificateOperationPrint.subProgram')
          }}</label>
          <a-select
            style="width: 100%"
            v-model.number="model.acps_id"
            :options="sub_programs"
          ></a-select>
          <div class="validate" v-if="errors.has('acps_id')">
            {{ errors.first('acps_id') }}
          </div>
        </div>
        <div class="col-md-6">
          <label class="required">{{
            $t('certificateOperationPrint.academicYear')
          }}</label>
          <a-select
            style="width: 100%"
            v-model.number="model.ac_year_id"
            :options="ac_year_list"
            :loading="fetching_academic_year"
            @change="acYearChange"
          ></a-select>
          <div class="validate" v-if="errors.has('ac_year_id')">
            {{ errors.first('ac_year_id') }}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6">
          <label class="required">{{
            $t('certificateOperationPrint.term')
          }}</label>
          <a-select
            style="width: 100%"
            v-model.number="model.ac_term_id"
            :options="acTerms"
            :show-search="true"
            :loading="fetching_academic_term"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            @change="acTermChange"
          ></a-select>
          <div class="ts-flex ts-justify-start text-danger">
            {{ errors.first('ac_term_id') }}
          </div>
        </div>
        <div
          class="col-md-6"
          v-if="
            model.certificate_type_id != 4 && model.certificate_type_id != 6
          "
        >
          <label class="required">{{
            $t('certificateOperationPrint.classOperation')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.class_id"
            :options="class_options"
            :show-search="true"
            :placeholder="$t('all')"
            :loading="fetching_class_operation"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
          ></a-select>
          <div class="validate" v-if="errors.has('class_id')">
            {{ errors.first('class_id') }}
          </div>
        </div>
        <div
          class="col-md-6"
          v-if="
            model.certificate_type_id == 4 || model.certificate_type_id == 6
          "
        >
          <label>
            {{ $t('school.academic.operation.classOperation.grade') }}
            <i class="fa fa-spinner spin" v-if="filterLevel"></i>
          </label>
          <select
            class="form-control"
            v-model="model.level_id"
            :class="{ 'is-invalid': errors.has('level_id') }"
          >
            <option value>{{ $t('select') }}</option>
            <option
              v-for="(level, index) in levelResource"
              :key="index"
              :value="level.level_id"
            >
              {{ level.level_name_foreign }}
            </option>
          </select>
          <div class="invalid-feedback" v-if="errors.has('level_id')">
            {{ errors.first('level_id') }}
          </div>
        </div>
      </div>
      <div
        class="row"
        v-if="model.certificate_type_id == 4 || model.certificate_type_id == 6"
      >
        <div class="col-md-6">
          <label>
            {{ $t('school.academic.operation.classOperation.level') }}
          </label>
          <select
            class="form-control"
            v-model="model.grade_id"
            :class="{ 'is-invalid': errors.has('grade_id') }"
          >
            <option value>{{ $t('select') }}</option>
            <option
              v-for="(grade, index) in grades"
              :key="index"
              :value="grade.grade_id"
            >
              {{ grade.grade_name_foreign }}
            </option>
          </select>
          <div class="invalid-feedback" v-if="errors.has('grade_id')">
            {{ errors.first('grade_id') }}
          </div>
        </div>
      </div>
      <div
        class="row mb-2"
        v-show="
          model.certificate_type_id == 1 ||
            (model.certificate_type_id == 2 && model.certificate_type_id != 4)
        "
      >
        <div class="col-md-6">
          <label class="required">{{
            $t('certificateOperationPrint.scoringCycle')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.scoring_cycle_id"
            :options="scoringCycles"
            @change="scoringCycleChange"
          >
          </a-select>
        </div>
        <div class="col-md-6">
          <label class="required">{{
            $t('certificateOperationPrint.cycleValue')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.cycle_value"
            :options="scoringCycleValues"
          >
          </a-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
          <ts-button
            class="btn-block"
            color="primary"
            @click.prevent="search"
            outline
            :waiting="waiting"
          >
            <i class="fas fa-search"></i> {{ $t('search') }}</ts-button
          >
        </div>
      </div>
      <fieldset>
        <legend>{{ $t('certificateOperationPrint.studentList') }}</legend>
        <ts-loading-banner :loading="fetchingStudent">
          <div class="row">
            <div
              class="col-md-6 ts-mb-2"
              v-show="
                model.certificate_type_id == 2 ||
                  model.certificate_type_id == 5 ||
                  model.certificate_type_id == 6
              "
            >
              <label class="required">{{
                $t('certificateOperationPrint.requestDate')
              }}</label>
              <a-date-picker
                v-model="model.printed_at"
                :allowClear="false"
                style="width: 100%"
                placeholder="DD-MM-YYYY"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                @change="onChangeRequestDate"
                :class="{
                  'is-invalid': errors.has('printed_at')
                }"
              />
              <div class="invalid-feedback" v-if="errors.has('printed_at')">
                {{ errors.first('printed_at') }}
              </div>
            </div>
            <div class="col-md-6">
              <label>{{ $t('search') }}</label>
              <a-input
                type="text"
                v-model="search_certificate"
                placeholder="card number|student name"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <a-table
                size="small"
                :columns="columns"
                v-if="model.certificate_type_id == 1"
                :data-source="studentLists"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
              </a-table>
              <a-table
                size="small"
                :columns="
                  model.certificate_type_id == 2
                    ? columnAppreciations
                    : model.certificate_type_id == 5
                    ? columnTranscripts
                    : columnAppreciations
                "
                v-if="
                  model.certificate_type_id == 2 ||
                    model.certificate_type_id == 5
                "
                :row-key="studentLists => studentLists"
                :data-source="studentLists"
                :row-selection="{ onChange: checkItem }"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
              </a-table>
              <a-table
                size="small"
                :columns="columnAwerd"
                v-if="model.certificate_type_id == 3"
                :data-source="studentLists"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
              </a-table>
              <a-table
                size="small"
                :columns="columnAcheivement"
                v-if="model.certificate_type_id == 4"
                :row-key="studentLists => studentLists.student_id"
                :data-source="studentLists"
                :row-selection="{ onChange: checkItem }"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
              </a-table>
              <a-table
                size="small"
                :columns="columnAcheivement"
                v-if="model.certificate_type_id == 6"
                :row-key="studentLists => studentLists.student_id"
                :data-source="studentLists"
                :row-selection="{ onChange: checkItem }"
                :scroll="{ y: 400 }"
              >
                <span slot="photo" slot-scope="text, record">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(record),
                      error: onError(record),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                </span>
              </a-table>
            </div>
          </div>
        </ts-loading-banner>
      </fieldset>
    </div>
    <div class="row">
      <div class="col-md-12 ts-flex ts-justify-between">
        <div class="ts-flex ts-justify-start text-danger">
          {{ errors.first('student_id_list') }}
        </div>
        <div class="ts-flex ts-justify-end ts-space-x-2">
          <ts-button @click.prevent="() => $emit('cancel')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onSave"
            >{{ $t('save') }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: 'certificateOperationPrintForm',
  data() {
    return {
      loading: false,
      waiting: false,
      fetchingStudent: false,
      fetching: false,
      errors: new Errors(),
      search_certificate: '',
      ac_year_list: [],
      main_programs: [],
      sub_programs: [],
      students: [],
      positions: [],
      model: {
        printed_at: moment().format('DD-MM-YYYY'),
        ac_year_id: null,
        acp_id: null,
        acps_id: null,
        student_id_list: []
      },
      boyPhoto: require('@/assets/student-default-boy.png'),
      girlPhoto: require('@/assets/student-default-girl.png')
    }
  },
  computed: {
    ...mapState('reportAcademic', ['studentStatus']),
    // 1 honorable
    columns() {
      return [
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 80
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 150
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name',
          width: 250
        },
        {
          title: this.$t('certificateOperationPrint.rank'),
          dataIndex: 'ranks',
          width: 70
        }
      ]
    },
    // 2 appreciatoin
    columnAppreciations() {
      return [
        {
          width: 20
        },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 100
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name',
          width: 250
        },
        {
          title: this.$t('certificateOperationPrint.skill'),
          dataIndex: 'comp_item_name',
          width: 180
        }
      ]
    },
    // 3 columnAwerd
    columnAwerd() {
      return [
        {
          width: 20
        },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 100
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.sex'),
          dataIndex: 'sex',
          width: 70
        },
        {
          title: this.$t('certificateOperationPrint.subProgram'),
          dataIndex: 'sub_name',
          width: 300
        }
      ]
    },
    // 4 acheivement
    columnAcheivement() {
      return [
        {
          width: 20
        },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 100
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name',
          width: 250
        },
        {
          title: this.$t('certificateOperationPrint.level'),
          dataIndex: 'grade_name_foreign',
          width: 180
        }
      ]
    },
    // 5 transcript
    columnTranscripts() {
      return [
        {
          width: 20
        },
        {
          title: this.$t('certificateOperationPrint.photo'),
          dataIndex: 'photo',
          key: 'photo',
          scopedSlots: { customRender: 'photo' },
          width: 100
        },
        {
          title: this.$t('certificateOperationPrint.cardNumber'),
          dataIndex: 'card_number',
          width: 120
        },
        {
          title: this.$t('certificateOperationPrint.studentName'),
          dataIndex: 'student_name',
          width: 250
        },
        {
          title: this.$t('certificateOperationPrint.level'),
          dataIndex: 'class_name',
          width: 180
        }
      ]
    },
    grades() {
      this.model.grade_id = ''
      if (this.levelResource.length > 0) {
        let level = this.levelResource.filter(
          l => l.level_id === this.model.level_id
        )
        if (level.length > 0) {
          return level[0].grades
        }
      }

      return []
    },
    scoringCycles() {
      if (this.model.acps_id) {
        let scoring_cyles = this.sub_programs.find(
          el => el.value == this.model.acps_id
        ).scoring_cyles
        return this.scoringCycle.filter(el => includes(scoring_cyles, el.value))
      }
      return this.scoringCycle
    },
    scoringCycleValues() {
      if (this.model.scoring_cycle_id) {
        return this.scoringCycleValue.filter(
          s => s.scoring_cycle_id == this.model.scoring_cycle_id
        )
      }
      return this.scoringCycleValue
    },
    acTerms() {
      if (this.model.scoring_cycle_id == 4) {
        return this.ac_terms.filter(s => s.term_order == 2)
      }
      return this.ac_terms
    },
    studentLists() {
      if (_.isEmpty(this.students)) return []

      if (this.search_certificate) {
        return _.orderBy(this.students, ['card_number'], ['asc']).filter(
          option => {
            if (
              option.card_number === null ||
              option.card_number === undefined ||
              option.student_name_en === null ||
              option.student_name_en === undefined
            )
              return false

            return (
              option.card_number
                .toLowerCase()
                .startsWith(this.search_certificate.toLowerCase()) ||
              option.student_name_en
                .toLowerCase()
                .startsWith(this.search_certificate.toLowerCase())
            )
          }
        )
      }
      return _.orderBy(this.students, ['card_number'], 'ASC')
    },
    mainProgramList() {
      if (this.model.certificate_type_id == 6) {
        return this.main_programs.filter(m => m.value !== 103)
      }
      return this.main_programs;
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('certificateOperationPrint', [
      'getYear',
      'getMainProgram',
      'getSubProgram'
    ]),
    // Fetch Data
    async fetchData() {
      this.loading = true
      await this.getMainProgram().then(response => {
        this.main_programs = response.data.map(el => ({
          value: el.acp_id,
          label: el.acp_name_foreign
        }))
      })
      await this.getYear()
        .then(response => {
          this.certificate_types = response.data.map(el => ({
            value: el.certificate_type_id,
            label: el.certificate_type
          }))
        })

      await this.getMainProgram()
        .then(response => {
          this.main_programs = response.data.map(el => ({
            value: el.acp_id,
            label: el.acp_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
      await this.getYear()
        .then(response => {
          this.ac_year_list = _.sortBy(response.data, ['ac_status_id']).map(
            el => ({
              value: el.ac_year_id,
              label:
                el.ac_year +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                  ? ' ( History ) '
                  : ' ( Next ) ')
            })
          )
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onCertificateTypeChange() {
      this.model.acp_id = null
    },
    onChangeRequestDate(dateString) {
      this.printed_at = dateString
    },
    //onMainProgramChange
    async onMainProgramChange(acp_id) {
      this.model.acps_id = null
      await this.getSubProgram({
        filter: {
          acp_id: acp_id
        }
      })
        .then(response => {
          this.sub_programs = response.data.map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign,
            scoring_cyles: el.scoring_cyles.map(el => el.scoring_cycle_id)
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    //onSubChange
    onSubChange(acps_id) {
      this.model.ac_term_id = null
      this.model.class_id = null
      if (this.model.ac_year_id) {
        this.fetching_academic_term = true
        this.getTerm({
          filter: {
            acps_id: acps_id,
            ac_status_id: '1,2,3',
            ac_year_id: this.model.ac_year_id
          }
        })
          .then(response => {
            this.ac_terms = response.data.map(el => ({
              value: el.ac_term_id,
              term_order: el.term_order,
              label:
                el.term_name +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                  ? ' ( History ) '
                  : '( Next )')
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.fetching_academic_term = false
          })
      }

      this.getScoringCycle({ acps_id: acps_id })
        .then(response => {
          this.scoringCycle = response.data
            .filter(s => s.scoring_cycle_id == 1)
            .map(el => ({
              value: el.scoring_cycle_id,
              label: el.scoring_cycle_name
            }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    //acYearChange
    acYearChange() {
      // this.model.acps_id = null
      this.model.ac_term_id = null
      this.model.class_id = null
      this.fetching_academic_term = true
      this.getTerm({
        filter: {
          acps_id: this.model.acps_id,
          ac_status_id: '1,2,3',
          ac_year_id: this.model.ac_year_id
        }
      })
        .then(response => {
          this.ac_terms = response.data.map(el => ({
            value: el.ac_term_id,
            term_order: el.term_order,
            label:
              el.ac_year +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : '( Next )')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      this.loading = false
    },
    //acTermChange
    acTermChange(ac_term_id) {
      this.term_order = this.ac_terms.find(
        el => el.value == this.model.ac_term_id
      ).term_order
      this.fetching_class_operation = true
      this.fetch_level = true
      this.model.class_id = null
      this.getClass({
        filter: {
          ac_term_id: ac_term_id,
        },
      })
        .then(response => {
          this.class_options = response.data.map(el => ({
            value: el.class_id,
            label:
              el.class_name +
              ' | ' +
              el.teacher.full_name_en +
              ' | ' +
              el.academic_study_time.study_time
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_class_operation = false
        })
    },
    getLevelBySub(acps_id) {
      this.filterLevel = true
      this.model.level_id = ''
      this.$store
        .dispatch('classOperation/getLevel', acps_id)
        .then(response => {
          this.levelResource = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.filterLevel = false
        })
    },
    // scoringCycleChange
    async scoringCycleChange(scoring_cycle_id) {
      await this.getScoringCycleValue({ scoring_cycle_id: scoring_cycle_id })
        .then(response => {
          this.scoringCycleValue = response.data.map(el => ({
            value: el.scoring_cycle_value,
            label: el.scoring_cycle_description,
            scoring_cycle_id: el.scoring_cycle_id
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
      if (this.model.scoring_cycle_id == 4) {
        this.class_options = []
        this.students = []
        this.model.ac_term_id = null
        this.model.class_id = null
        this.model.cycle_value = null
      }
      if (
        this.model.scoring_cycle_id == 0 ||
        this.model.scoring_cycle_id == 2 ||
        this.model.scoring_cycle_id == 3 ||
        this.model.scoring_cycle_id == 6
      ) {
        this.model.cycle_value = this.ac_terms.find(
          el => el.value == this.model.ac_term_id
        ).term_order
      } else {
        this.model.cycle_value = null
      }
    },
    search() {
      this.errors = new Errors()
      this.fetchingStudent = true
      this.model.student_id_list = []
      this.$store
        .dispatch('certificateOperationPrint/searchStudent', this.model)
        .then(response => {
          this.students = response.data
          this.students.forEach(stu => {
            this.model.student_id_list.push(stu.student_id)
          })
        })
        .catch(error => {
          this.$notify({ type: 'errors', text: error.message })
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.fetchingStudent = false
        })
    },
    checkItem(selectedRowKeys, selectedRows) {
      this.model.student_id_list = []
      selectedRows.forEach(el => {
        this.model.student_id_list.push({
          student_id: el.student_id ? el.student_id : null,
          ac_year_id: el.ac_year_id ? el.ac_year_id : null,
          acp_id: el.acp_id ? el.acp_id : null,
          acps_id: this.model.acps_id,
          printed_at: this.model.printed_at
        })
      })
    },
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('certificateOperationPrint/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    photoStudent(record) {
      if (record.photo) {
        return record.photo
      }

      return record.sex == 'Male' ? this.boyPhoto : this.girlPhoto
    },
    onError(record) {
      event
        ? (event.target.src =
            record.sex == 'Male' ? this.boyPhoto : this.girlPhoto)
        : ''
    }
  },
  watch: {
    'model.acps_id': function(value) {
      if (value) {
        this.getLevelBySub(value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  margin-bottom: 0 !important;
}
</style>
